// Neo Bento Portfolio page — monolithic iframe block (p_4)
// Multi-brand: noir / atelier / pulse / garden

export type NeoPortfolioBrand = 'noir' | 'atelier' | 'pulse' | 'garden'
export interface NeoPortfolioPageData { brand?: NeoPortfolioBrand }
export const DEFAULT_NEO_PORTFOLIO_DATA: NeoPortfolioPageData = { brand: 'noir' }

// ── CSS ───────────────────────────────────────────────────────────────────────
const NEO_PORTFOLIO_CSS = `
@import url('https://cdn.jsdelivr.net/npm/@fontsource/unbounded@5/cyrillic-500-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/unbounded@5/latin-500-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/unbounded@5/cyrillic-800-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/unbounded@5/latin-800-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/tektur@5/cyrillic-500-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/tektur@5/latin-500-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/tektur@5/cyrillic-700-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/tektur@5/latin-700-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond@5/cyrillic-500-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond@5/latin-500-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond@5/cyrillic-600-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond@5/latin-600-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond@5/cyrillic-500-italic.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond@5/latin-500-italic.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/playfair-display@5/cyrillic-500-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/playfair-display@5/latin-500-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/playfair-display@5/cyrillic-600-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/playfair-display@5/latin-600-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/playfair-display@5/cyrillic-500-italic.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/playfair-display@5/latin-500-italic.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/manrope@5/cyrillic-400-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/manrope@5/latin-400-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/manrope@5/cyrillic-600-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/manrope@5/latin-600-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/manrope@5/cyrillic-700-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/manrope@5/latin-700-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/jetbrains-mono@5/cyrillic-400-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/jetbrains-mono@5/latin-400-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/jetbrains-mono@5/cyrillic-600-normal.css');
@import url('https://cdn.jsdelivr.net/npm/@fontsource/jetbrains-mono@5/latin-600-normal.css');

/* ============ БАЗА / ТЕМЫ ============ */
:root{
  --fb:'Manrope',system-ui,sans-serif;
  --fm:'JetBrains Mono',monospace;
}
[data-theme="noir"]{
  --bg:#0A0A0B; --card:#141416; --card2:#1C1C1F; --ink:#F2F0E9; --muted:#8B897F;
  --line:rgba(242,240,233,.13); --acc:#D9FF3C; --acc2:#D9FF3C; --acc-ink:#0A0A0B;
  --fd:'Unbounded',sans-serif; --radius:6px; --ift:grayscale(1) contrast(1.1);
  --noise:.07; --sh:0 24px 50px -30px rgba(0,0,0,.9);
}
[data-theme="atelier"]{
  --bg:#F3EDE2; --card:#FBF7EE; --card2:#EBE2D1; --ink:#221C15; --muted:#7C7060;
  --line:rgba(34,28,21,.16); --acc:#C0532A; --acc2:#6B7F5E; --acc-ink:#F8F3E9;
  --fd:'Cormorant Garamond',serif; --radius:22px; --ift:sepia(.22) saturate(.92) contrast(1.02);
  --noise:.05; --sh:0 24px 44px -30px rgba(60,40,20,.35);
}
[data-theme="pulse"]{
  --bg:#06060E; --card:#0C0D18; --card2:#13142A; --ink:#EAEAF4; --muted:#7A7B90;
  --line:rgba(234,234,244,.13); --acc:#00E6A0; --acc2:#7B5CFF; --acc-ink:#04110C;
  --fd:'Tektur',sans-serif; --radius:14px; --ift:saturate(1.35) hue-rotate(-8deg) contrast(1.05);
  --noise:.10; --sh:0 0 40px -8px rgba(0,230,160,.25);
}
[data-theme="garden"]{
  --bg:#E8EEE2; --card:#F7F9F1; --card2:#DCE7D1; --ink:#1E2A1C; --muted:#5F6E58;
  --line:rgba(30,42,28,.15); --acc:#2F6B3A; --acc2:#F2B84B; --acc-ink:#F3F7EC;
  --fd:'Playfair Display',serif; --radius:30px; --ift:saturate(1.08) brightness(1.04);
  --noise:.045; --sh:0 24px 44px -28px rgba(30,60,30,.35);
}
*{margin:0;padding:0;box-sizing:border-box}
html{scroll-behavior:smooth}
body{
  background:var(--bg); color:var(--ink); font:400 16px/1.6 var(--fb);
  transition:background .6s ease,color .6s ease; overflow-x:hidden;
}
[data-theme="pulse"] body{
  background-image:linear-gradient(rgba(123,92,255,.05) 1px,transparent 1px),
                   linear-gradient(90deg,rgba(123,92,255,.05) 1px,transparent 1px);
  background-size:46px 46px;
}
::selection{background:var(--acc);color:var(--acc-ink)}
img{display:block;max-width:100%}
a{color:inherit;text-decoration:none}
button{font-family:inherit}
:focus-visible{outline:2px solid var(--acc);outline-offset:3px;border-radius:4px}
.fd{font-family:var(--fd)}
.mono{font-family:var(--fm);letter-spacing:.12em;text-transform:uppercase}
.wrap{max-width:1320px;margin:0 auto;padding:0 clamp(16px,4vw,44px)}
section{scroll-margin-top:96px}

/* шум */
.noise{position:fixed;inset:-60%;width:220%;height:220%;pointer-events:none;z-index:60;opacity:var(--noise);mix-blend-mode:overlay;
  background:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='240'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='240' height='240' filter='url(%23n)' opacity='0.55'/%3E%3C/svg%3E");
  animation:grain 9s steps(10) infinite}
@keyframes grain{0%{transform:translate(0,0)}20%{transform:translate(-4%,3%)}40%{transform:translate(3%,-5%)}60%{transform:translate(-5%,-2%)}80%{transform:translate(4%,4%)}100%{transform:translate(0,0)}}

/* прогресс */
#progress{position:fixed;top:0;left:0;height:3px;width:0;background:var(--acc);z-index:120;transition:background .6s}

/* ============ ШАПКА ============ */
.hdr{position:sticky;top:0;z-index:100;background:color-mix(in srgb,var(--bg) 82%,transparent);backdrop-filter:blur(14px);border-bottom:1px solid var(--line);transition:background .6s,border-color .6s}
.hdr-in{display:flex;align-items:center;gap:18px;height:70px}
.brand{display:flex;align-items:center;gap:10px;font:800 18px/1 var(--fd);letter-spacing:.02em}
.brand-dot{width:14px;height:14px;background:var(--acc);transition:.5s;border-radius:3px}
[data-theme="atelier"] .brand-dot{border-radius:50%;background:transparent;border:2px solid var(--acc)}
[data-theme="pulse"] .brand-dot{border-radius:50%;background:var(--acc);box-shadow:0 0 14px var(--acc)}
[data-theme="garden"] .brand-dot{border-radius:60% 40% 55% 45%/50% 60% 40% 50%;background:var(--acc)}
.brand sup{font-size:9px;color:var(--muted)}
.nav{display:flex;gap:26px;margin:0 auto}
.nav a{font:600 12px/1 var(--fm);letter-spacing:.16em;text-transform:uppercase;color:var(--muted);position:relative;padding:6px 0;transition:color .3s}
.nav a::after{content:'';position:absolute;left:0;bottom:0;height:2px;width:0;background:var(--acc);transition:width .35s}
.nav a:hover{color:var(--ink)} .nav a:hover::after{width:100%}
.switcher{display:flex;gap:4px;align-items:center;border:1px solid var(--line);border-radius:999px;padding:5px 7px;background:color-mix(in srgb,var(--card) 72%,transparent);transition:.5s}
.sw{display:flex;align-items:center;gap:7px;font:600 10px/1 var(--fm);letter-spacing:.14em;color:var(--muted);background:none;border:0;cursor:pointer;padding:7px 9px;border-radius:999px;transition:.3s}
.sw i{width:9px;height:9px;border-radius:50%;background:var(--d);transition:.3s}
.sw .lb{transition:.3s}
.sw:hover{color:var(--ink)}
.sw.is-on{color:var(--ink);background:var(--card2)}
.sw.is-on i{box-shadow:0 0 0 3px color-mix(in srgb,var(--d) 30%,transparent)}
.burger{display:none;width:44px;height:44px;border:1px solid var(--line);border-radius:var(--radius);background:var(--card);cursor:pointer;position:relative;z-index:130}
.burger span{position:absolute;left:12px;right:12px;height:2px;background:var(--ink);transition:.4s;top:18px}
.burger span:last-child{top:25px}
body.lock .burger span:first-child{transform:translateY(3.5px) rotate(45deg)}
body.lock .burger span:last-child{transform:translateY(-3.5px) rotate(-45deg)}

/* мобильное меню */
.mmenu{position:fixed;inset:0;z-index:110;background:var(--bg);display:flex;flex-direction:column;justify-content:space-between;padding:110px 8vw 40px;clip-path:inset(0 0 100% 0);transition:clip-path .6s cubic-bezier(.7,0,.2,1);visibility:hidden}
.mmenu.open{clip-path:inset(0);visibility:visible}
.mmenu nav a{display:block;font:600 clamp(34px,9vw,56px)/1.25 var(--fd);color:var(--ink);opacity:0;transform:translateY(24px);transition:.5s}
.mmenu.open nav a{opacity:1;transform:none}
.mmenu.open nav a:nth-child(2){transition-delay:.08s}.mmenu.open nav a:nth-child(3){transition-delay:.16s}.mmenu.open nav a:nth-child(4){transition-delay:.24s}
.mmenu nav a em{font-style:normal;color:var(--acc)}
.mmenu-foot{display:flex;flex-wrap:wrap;gap:14px;justify-content:space-between;align-items:center;color:var(--muted);font:600 12px/1 var(--fm);letter-spacing:.12em}

/* ============ BENTO СЕТКА ============ */
.grid{display:grid;grid-template-columns:repeat(12,1fr);gap:clamp(10px,1.4vw,18px)}
.c3{grid-column:span 3}.c4{grid-column:span 4}.c5{grid-column:span 5}.c6{grid-column:span 6}.c7{grid-column:span 7}.c8{grid-column:span 8}.c12{grid-column:span 12}
.r2{grid-row:span 2}
.card{position:relative;background:var(--card);border:1px solid var(--line);border-radius:var(--radius);overflow:hidden;transition:background .6s,border-color .6s,border-radius .6s,transform .4s,box-shadow .4s}
.lift:hover{transform:translateY(-5px);box-shadow:var(--sh)}
.pad{padding:clamp(18px,2.4vw,30px)}
.card.acc{background:var(--acc);color:var(--acc-ink);border-color:transparent}
.card.acc2{background:var(--acc2);color:var(--acc-ink);border-color:transparent}
.ift{filter:var(--ift);transition:filter .7s,transform .8s cubic-bezier(.2,.6,.2,1)}
.kick{font:600 11px/1 var(--fm);letter-spacing:.2em;text-transform:uppercase;color:var(--muted)}
.hl{background:linear-gradient(transparent 58%,color-mix(in srgb,var(--acc) 45%,transparent) 0)}

/* reveal */
.js .rv{opacity:0;transform:translateY(26px);transition:opacity .8s ease,transform .8s cubic-bezier(.2,.6,.2,1)}
.js .rv.in{opacity:1;transform:none}
.lm{display:block;overflow:hidden}
.js .lm>span{display:block;transform:translateY(112%);transition:transform .9s cubic-bezier(.2,.65,.15,1)}
.js .in .lm>span,.js .lm.in>span{transform:none}

/* ============ HERO ============ */
.hero{padding-top:clamp(18px,3vw,34px)}
.hero-main{display:flex;flex-direction:column;justify-content:space-between;gap:26px}
.hero-main h1{font:800 clamp(30px,4.6vw,62px)/1.06 var(--fd);letter-spacing:-.01em}
[data-theme="atelier"] .hero-main h1{font-weight:600;font-size:clamp(36px,5.4vw,76px);line-height:1}
[data-theme="garden"] .hero-main h1{font-weight:600;font-size:clamp(34px,5vw,70px)}
[data-theme="pulse"] .hero-main h1{letter-spacing:.02em}
.emx{font-style:normal;color:var(--acc)}
[data-theme="atelier"] .emx{font-style:italic;color:var(--acc)}
[data-theme="garden"] .emx{font-style:italic}
.lead{font:500 clamp(15px,1.4vw,18px)/1.6 var(--fb);color:var(--muted);max-width:52ch;transition:opacity .3s,transform .3s}
.lead.swap{opacity:0;transform:translateY(8px)}
.cta-row{display:flex;flex-wrap:wrap;gap:12px}
.btn{display:inline-flex;align-items:center;gap:10px;padding:15px 24px;border-radius:var(--radius);border:1px solid var(--line);font:700 13px/1 var(--fb);letter-spacing:.04em;color:var(--ink);background:transparent;cursor:pointer;transition:.35s}
.btn.prime{background:var(--acc);color:var(--acc-ink);border-color:var(--acc)}
.btn:hover{transform:translateY(-3px)}
[data-theme="noir"] .btn.prime:hover{box-shadow:6px 6px 0 rgba(217,255,60,.28)}
[data-theme="pulse"] .btn.prime:hover{box-shadow:0 0 32px rgba(0,230,160,.4)}
[data-theme="atelier"] .btn:hover,[data-theme="garden"] .btn:hover{box-shadow:var(--sh)}
.meta-line{font:500 11px/1.7 var(--fm);letter-spacing:.14em;text-transform:uppercase;color:var(--muted)}

.hero-photo{min-height:440px}
.hero-photo .ph{position:absolute;inset:0}
.hero-photo img{width:100%;height:100%;object-fit:cover}
.kb img{animation:kb 16s ease-in-out infinite alternate}
@keyframes kb{from{transform:scale(1)}to{transform:scale(1.1) translate(1.6%,-1.6%)}}
.hero-photo .cap{position:absolute;left:0;right:0;bottom:0;padding:16px 20px;display:flex;justify-content:space-between;gap:10px;background:linear-gradient(transparent,rgba(0,0,0,.72));color:#F2F0E9;font:600 10px/1.5 var(--fm);letter-spacing:.16em;text-transform:uppercase}

/* marquee */
.mq{overflow:hidden;display:flex;align-items:center}
.mq-t{display:flex;width:max-content;animation:mq 26s linear infinite}
.mq:hover .mq-t{animation-play-state:paused}
.mq-g{display:flex;align-items:center;gap:34px;padding:0 17px;font:600 clamp(13px,1.4vw,17px)/1 var(--fm);letter-spacing:.2em;text-transform:uppercase;white-space:nowrap}
.mq-g b{color:var(--acc);font-weight:600}
@keyframes mq{to{transform:translateX(-50%)}}
.rev .mq-t{animation-direction:reverse}

/* статистика */
.stat b{display:block;font:800 clamp(34px,3.6vw,52px)/1 var(--fd);letter-spacing:-.01em}
[data-theme="atelier"] .stat b{font-weight:600}
.stat span{font:600 10px/1.5 var(--fm);letter-spacing:.16em;text-transform:uppercase;color:var(--muted)}
.dot{width:9px;height:9px;border-radius:50%;background:var(--acc);position:relative;flex:none}
.dot::after{content:'';position:absolute;inset:-5px;border-radius:50%;border:1px solid var(--acc);animation:ping 1.8s ease-out infinite}
@keyframes ping{from{transform:scale(.4);opacity:1}to{transform:scale(1.5);opacity:0}}
.clock{font:600 clamp(22px,2.2vw,30px)/1 var(--fm);letter-spacing:.06em}

/* ============ РАБОТЫ ============ */
.shead{display:flex;align-items:flex-end;justify-content:space-between;gap:20px;margin:clamp(56px,8vw,110px) 0 26px}
.shead h2{font:800 clamp(28px,4vw,54px)/1.1 var(--fd);letter-spacing:-.01em}
[data-theme="atelier"] .shead h2,[data-theme="garden"] .shead h2{font-weight:600}
.pcard{display:block}
.pcard .media{overflow:hidden;background:var(--card2)}
.pcard .media img{width:100%;height:100%;object-fit:cover}
.pcard:hover .media img{transform:scale(1.06)}
.pnum,.pyear{position:absolute;top:14px;font:600 10px/1 var(--fm);letter-spacing:.14em;padding:7px 10px;border-radius:999px;background:rgba(8,8,10,.55);color:#F2F0E9;backdrop-filter:blur(6px);z-index:2}
.pnum{left:14px}.pyear{right:14px}
.cover .media{position:absolute;inset:0}
.cover .pinfo{position:absolute;left:0;right:0;bottom:0;padding:20px 22px;display:flex;align-items:flex-end;gap:14px;background:linear-gradient(transparent,rgba(5,5,8,.78));color:#F5F3EC}
.cover .pinfo p{color:rgba(245,243,236,.75)}
.pinfo h3{font:700 clamp(19px,1.8vw,26px)/1.1 var(--fd)}
[data-theme="atelier"] .pinfo h3,[data-theme="garden"] .pinfo h3{font-weight:600}
.pinfo p{font:500 12px/1.5 var(--fm);letter-spacing:.1em;text-transform:uppercase;color:var(--muted);margin-top:5px}
.arw{margin-left:auto;font-size:22px;transition:transform .35s;flex:none}
.pcard:hover .arw{transform:translate(6px,-6px)}
.pcard:not(.cover) .pinfo{padding:18px 20px 20px}
.pcard:not(.cover) .media{aspect-ratio:4/3}
.cta-card{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:22px 28px}
.cta-card .fd{font:700 clamp(18px,2.4vw,30px)/1.2 var(--fd)}
[data-theme="atelier"] .cta-card .fd,[data-theme="garden"] .cta-card .fd{font-weight:600}
.cta-card:hover .arw{transform:translateX(10px)}
.cta-card .arw{font-size:30px}

/* ============ УСЛУГИ ============ */
.srow{display:grid;grid-template-columns:90px 1.1fr 1fr auto;gap:26px;align-items:center;padding:clamp(22px,3vw,36px) 6px;border-top:1px solid var(--line);transition:.4s}
.srow:last-child{border-bottom:1px solid var(--line)}
.srow .idx{font:600 13px/1 var(--fm);color:var(--muted);letter-spacing:.14em;transition:.3s}
.srow h3{font:700 clamp(20px,2.6vw,34px)/1.15 var(--fd)}
[data-theme="atelier"] .srow h3,[data-theme="garden"] .srow h3{font-weight:600}
.srow p{color:var(--muted);font-size:14.5px;max-width:46ch}
.chips{display:flex;flex-wrap:wrap;gap:8px;margin-top:12px}
.chip{font:600 10px/1 var(--fm);letter-spacing:.12em;text-transform:uppercase;padding:7px 11px;border:1px solid var(--line);border-radius:999px;color:var(--muted);transition:.3s}
.srow:hover{background:var(--card);padding-left:20px;padding-right:20px;border-radius:var(--radius)}
.srow:hover .idx{color:var(--acc)}
.srow .arw{font-size:26px;color:var(--muted)}
.srow:hover .arw{color:var(--acc);transform:translateX(6px)}

/* ============ СТУДИЯ ============ */
.about p.big{font:500 clamp(17px,1.8vw,23px)/1.55 var(--fb)}
[data-theme="atelier"] .about p.big,[data-theme="garden"] .about p.big{font-family:var(--fd);font-size:clamp(19px,2vw,26px)}
.about .sig{margin-top:22px;font:600 11px/1 var(--fm);letter-spacing:.18em;text-transform:uppercase;color:var(--muted)}
.award{display:flex;justify-content:space-between;gap:14px;padding:13px 0;border-top:1px solid var(--line);font-size:14px}
.award:first-of-type{border-top:0}
.award b{font-weight:600}
.award span{color:var(--muted);font:500 11px/1.8 var(--fm);letter-spacing:.1em}
.tst-q{font:500 clamp(17px,1.7vw,22px)/1.5 var(--fb);transition:opacity .35s,transform .35s}
[data-theme="atelier"] .tst-q,[data-theme="garden"] .tst-q{font-family:var(--fd);font-style:italic;font-size:clamp(19px,1.9vw,25px)}
.tst-a{margin-top:16px;font:600 11px/1.6 var(--fm);letter-spacing:.14em;text-transform:uppercase;color:var(--muted)}
.tst-q.fade{opacity:0;transform:translateY(10px)}
.tst-bar{height:2px;background:var(--line);margin-top:22px;overflow:hidden;border-radius:2px}
.tst-bar i{display:block;height:100%;background:var(--acc);width:0}
.tst-bar i.run{animation:tbar 6s linear forwards}
@keyframes tbar{from{width:0}to{width:100%}}
.clients .mq-g{font-size:clamp(16px,1.8vw,22px);letter-spacing:.26em}
.hire .fd{font:700 clamp(20px,2vw,28px)/1.25 var(--fd)}
.toolgrid{display:flex;flex-wrap:wrap;gap:9px}

/* ============ КОНТАКТЫ ============ */
.contact-card{display:grid;grid-template-columns:1.2fr .8fr;gap:clamp(24px,3vw,50px)}
.contact-card h2{font:800 clamp(30px,4vw,56px)/1.08 var(--fd)}
[data-theme="atelier"] .contact-card h2,[data-theme="garden"] .contact-card h2{font-weight:600}
.mail{display:inline-block;margin-top:26px;font:700 clamp(20px,3vw,40px)/1.2 var(--fd);color:var(--ink);background:none;border:0;border-bottom:2px solid var(--acc);cursor:pointer;padding:4px 0;transition:.3s;text-align:left}
[data-theme="atelier"] .mail,[data-theme="garden"] .mail{font-weight:600;font-style:italic}
.mail:hover{color:var(--acc);letter-spacing:.02em}
.clist div{display:flex;justify-content:space-between;gap:14px;padding:14px 0;border-top:1px solid var(--line);font-size:14px}
.clist div:first-child{border-top:0}
.clist span{color:var(--muted);font:600 10px/2 var(--fm);letter-spacing:.16em;text-transform:uppercase}

/* ============ ФУТЕР ============ */
.brandbar{border-top:1px solid var(--line);border-bottom:1px solid var(--line);margin-top:clamp(60px,9vw,120px)}
.brandbar .mq-g{padding:20px 17px;color:var(--muted)}
footer{padding:clamp(30px,5vw,60px) 0 30px}
.wm{font:900 clamp(110px,26vw,340px)/0.95 var(--fd);letter-spacing:.02em;text-align:center;color:transparent;-webkit-text-stroke:2px color-mix(in srgb,var(--ink) 30%,transparent);transition:.6s;user-select:none}
.wm:hover{color:var(--acc);-webkit-text-stroke:2px var(--acc)}
[data-theme="atelier"] .wm{font-weight:600;-webkit-text-stroke:0;color:var(--ink);opacity:.9}
[data-theme="pulse"] .wm{-webkit-text-stroke:2px var(--acc);text-shadow:0 0 60px rgba(0,230,160,.3)}
[data-theme="garden"] .wm{font-weight:600;-webkit-text-stroke:0;color:var(--acc)}
.foot-row{display:flex;flex-wrap:wrap;gap:14px;justify-content:space-between;align-items:center;margin-top:26px;color:var(--muted);font:600 11px/1.8 var(--fm);letter-spacing:.14em;text-transform:uppercase}
.foot-row a:hover{color:var(--acc)}

/* toast */
.toast{position:fixed;left:50%;bottom:26px;transform:translate(-50%,80px);background:var(--ink);color:var(--bg);font:700 12px/1 var(--fm);letter-spacing:.1em;padding:14px 22px;border-radius:999px;z-index:200;transition:transform .45s cubic-bezier(.2,.8,.2,1);pointer-events:none}
.toast.show{transform:translate(-50%,0)}

/* ============ АДАПТИВ ============ */
@media(max-width:1080px){
  .grid{grid-template-columns:repeat(6,1fr)}
  .c7,.c5,.c6,.c8{grid-column:span 6}
  .c4{grid-column:span 3}.c3{grid-column:span 3}
  .nav{display:none}
  .burger{display:block}
  .srow{grid-template-columns:60px 1fr auto;grid-template-rows:auto auto}
  .srow p{grid-column:2/4}
  .contact-card{grid-template-columns:1fr}
}
@media(max-width:680px){
  .grid{grid-template-columns:repeat(2,1fr)}
  .cell{grid-column:span 2!important}
  .sm1{grid-column:span 1!important}
  .hero-photo{min-height:400px}
  .sw .lb{display:none}
  .shead{flex-direction:column;align-items:flex-start;gap:8px}
  .srow{grid-template-columns:1fr;gap:10px;padding:24px 4px}
  .srow .arw{display:none}
  .hdr-in{height:62px;gap:10px}
  .switcher{margin-left:auto}
}
@media(hover:none){.lift:hover,.pcard:hover{transform:none}}

/* reduced motion */
@media (prefers-reduced-motion:reduce){
  html{scroll-behavior:auto}
  *,*::before,*::after{animation-duration:.001s!important;animation-iteration-count:1!important;transition-duration:.15s!important}
  .mq-t{animation:none;transform:none}
  .kb img{animation:none}
  .noise{animation:none}
}
`

// ── HTML Body ─────────────────────────────────────────────────────────────────
const NEO_PORTFOLIO_HTML_BODY = `
<div class="noise" aria-hidden="true"></div>
<div id="progress" aria-hidden="true"></div>

<!-- ШАПКА -->
<header class="hdr">
  <div class="wrap hdr-in">
    <a class="brand" href="#top"><span class="brand-dot"></span>BST<sup>®</sup></a>
    <nav class="nav">
      <a href="#works">Работы</a><a href="#services">Услуги</a><a href="#studio">Студия</a><a href="#contact">Контакты</a>
    </nav>
    <div class="switcher" role="group" aria-label="Вариант бренда">
      <button class="sw is-on" data-set-theme="noir"    style="--d:#D9FF3C" aria-label="BST Noir"><i></i><span class="lb">NOIR</span></button>
      <button class="sw" data-set-theme="atelier" style="--d:#C0532A" aria-label="BST Atelier"><i></i><span class="lb">ATELIER</span></button>
      <button class="sw" data-set-theme="pulse"   style="--d:#00E6A0" aria-label="BST Pulse"><i></i><span class="lb">PULSE</span></button>
      <button class="sw" data-set-theme="garden"  style="--d:#2F6B3A" aria-label="BST Garden"><i></i><span class="lb">GARDEN</span></button>
    </div>
    <button class="burger" id="burger" aria-label="Меню"><span></span><span></span></button>
  </div>
</header>

<!-- МОБИЛЬНОЕ МЕНЮ -->
<div class="mmenu" id="mmenu">
  <nav>
    <a href="#works"><em>01</em> Работы</a>
    <a href="#services"><em>02</em> Услуги</a>
    <a href="#studio"><em>03</em> Студия</a>
    <a href="#contact"><em>04</em> Контакты</a>
  </nav>
  <div class="mmenu-foot">
    <span>hello@bst.studio</span><span>Москва · 55.75°N 37.61°E</span>
  </div>
</div>

<main id="top">
<!-- ============ HERO BENTO ============ -->
<section class="wrap hero">
  <div class="grid">

    <div class="cell c7 r2 card lift pad hero-main rv">
      <div>
        <p class="kick">BST® / <span id="themeName">NOIR</span> — независимая студия · Москва</p>
        <h1 style="margin-top:20px">
          <span class="scr" data-t="heroLine1" data-text="Дизайн, который">Дизайн, который</span><br>
          <span class="scr" data-t="heroLine2" data-text="двигает">двигает</span> <em class="emx" data-t="heroAccent">бренды</em>
        </h1>
        <p class="lead" id="tagline" style="margin-top:18px">Форма. Ритм. Контраст.</p>
      </div>
      <div>
        <div class="cta-row">
          <a class="btn prime" href="#contact">Обсудить проект ↗</a>
          <a class="btn" href="#works">Смотреть работы</a>
        </div>
        <p class="meta-line" data-t="heroMeta" style="margin-top:22px">Айдентика · Веб · Motion · 3D — с 2013 года</p>
      </div>
    </div>

    <div class="cell c5 r2 card hero-photo rv">
      <div class="ph kb"><img data-img="heroImg" class="ift" src="https://image.qwenlm.ai/public_source/5672be58-e319-4824-8079-cc817b4ada46/1d267ed79-ac89-49da-b89f-7079cc6850f5.png" alt="Арт-директор студии BST"></div>
      <div class="cap"><span data-t="heroCap1">Команда BST · Москва</span><span data-t="heroCap2">EST. 2013</span></div>
    </div>

    <div class="cell c12 card mq rv" aria-hidden="true">
      <div class="mq-t">
        <div class="mq-g"><span>Брендинг</span><b>✳</b><span>Веб-дизайн</span><b>✳</b><span>Разработка</span><b>✳</b><span>Motion</span><b>✳</b><span>3D</span><b>✳</b><span>Стратегия</span><b>✳</b><span>Арт-дирекшн</span><b>✳</b></div>
        <div class="mq-g"><span>Брендинг</span><b>✳</b><span>Веб-дизайн</span><b>✳</b><span>Разработка</span><b>✳</b><span>Motion</span><b>✳</b><span>3D</span><b>✳</b><span>Стратегия</span><b>✳</b><span>Арт-дирекшн</span><b>✳</b></div>
      </div>
    </div>

    <div class="cell c6 card lift pad rv" style="display:flex;gap:clamp(18px,3vw,44px);flex-wrap:wrap">
      <div class="stat"><b><span class="count" data-to="12">0</span></b><span data-t="stat1L">лет практики</span></div>
      <div class="stat"><b><span class="count" data-to="140" data-suf="+">0</span></b><span data-t="stat2L">проектов выпущено</span></div>
      <div class="stat"><b><span class="count" data-to="26">0</span></b><span data-t="stat3L">международных наград</span></div>
    </div>

    <div class="cell c3 card lift pad sm1 rv">
      <div style="display:flex;align-items:center;gap:10px"><span class="dot"></span><span class="kick" data-t="openBadge" style="color:var(--ink)">Открыты к проектам</span></div>
      <p class="clock" id="clock" style="margin-top:16px">00:00:00</p>
      <p class="kick" data-t="cityLabel" style="margin-top:8px">MSK · Москва</p>
    </div>

    <div class="cell c3 card lift pad sm1 rv">
      <p class="kick">Сейчас в работе</p>
      <p class="fd" id="focusTxt" style="font-size:clamp(16px,1.5vw,20px);font-weight:700;margin-top:14px;line-height:1.35">Финтех-платформа ORBITA</p>
    </div>

  </div>
</section>

<!-- ============ РАБОТЫ ============ -->
<section class="wrap" id="works">
  <div class="shead rv">
    <div>
      <p class="kick">01 · Работы</p>
      <h2 class="lm" style="margin-top:10px"><span class="scr" data-text="Избранные проекты">Избранные проекты</span></h2>
    </div>
    <span class="kick">05 / 140</span>
  </div>

  <div class="grid">
    <a class="cell c7 r2 card pcard cover tilt rv" href="#contact">
      <div class="media"><img data-img="p1img" class="ift" loading="lazy" src="https://image.qwenlm.ai/public_source/5672be58-e319-4824-8079-cc817b4ada46/10461ffa8-426b-4c8f-be83-f38958d5e5ff.png" alt="Aurum — 3D-арт-дирекшн"></div>
      <span class="pnum">01</span><span class="pyear">2025</span>
      <div class="pinfo"><div><h3 data-t="p1Title">Aurum</h3><p data-t="p1Desc">3D-арт-дирекшн · Digital-кампания</p></div><span class="arw">→</span></div>
    </a>

    <a class="cell c5 r2 card pcard cover tilt rv" href="#contact">
      <div class="media"><img data-img="p2img" class="ift" loading="lazy" src="https://image.qwenlm.ai/public_source/5672be58-e319-4824-8079-cc817b4ada46/1e07081d7-d66d-48d4-a084-0b153f909627.png" alt="Terra — айдентика и упаковка"></div>
      <span class="pnum">02</span><span class="pyear">2024</span>
      <div class="pinfo"><div><h3 data-t="p2Title">Terra</h3><p data-t="p2Desc">Айдентика · Упаковка · Фото</p></div><span class="arw">→</span></div>
    </a>

    <a class="cell c4 card pcard tilt rv" href="#contact">
      <div class="media"><img data-img="p3img" class="ift" loading="lazy" src="https://image.qwenlm.ai/public_source/5672be58-e319-4824-8079-cc817b4ada46/19a4ba481-9936-435d-a4a3-011850619ca9.png" alt="Pulse — финтех-платформа"></div>
      <span class="pnum">03</span><span class="pyear">2025</span>
      <div class="pinfo"><h3 data-t="p3Title">Pulse</h3><p data-t="p3Desc">Продукт · UX/UI · Разработка</p></div>
    </a>

    <a class="cell c4 card pcard tilt rv" href="#contact">
      <div class="media"><img data-img="p4img" class="ift" loading="lazy" src="https://image.qwenlm.ai/public_source/5672be58-e319-4824-8079-cc817b4ada46/1068c2770-1a77-4807-9275-a8fe582d9841.png" alt="Mono House — сайт архитектурного бюро"></div>
      <span class="pnum">04</span><span class="pyear">2024</span>
      <div class="pinfo"><h3 data-t="p4Title">Mono House</h3><p data-t="p4Desc">Сайт бюро · Арт-дирекшн</p></div>
    </a>

    <a class="cell c4 card pcard tilt rv" href="#contact">
      <div class="media"><img data-img="p5img" class="ift" loading="lazy" src="https://image.qwenlm.ai/public_source/5672be58-e319-4824-8079-cc817b4ada46/1e270e04b-bc43-401a-bded-30da5493b43b.png" alt="Signal Fest — айдентика фестиваля"></div>
      <span class="pnum">05</span><span class="pyear">2023</span>
      <div class="pinfo"><h3 data-t="p5Title">Signal Fest</h3><p data-t="p5Desc">Айдентика · Полиграфия</p></div>
    </a>

    <a class="cell c12 card lift cta-card rv" href="#contact">
      <span class="fd" data-t="worksCtaText">Смотреть все 140 проектов</span><span class="arw">→</span>
    </a>
  </div>
</section>

<!-- ============ УСЛУГИ ============ -->
<section class="wrap" id="services">
  <div class="shead rv">
    <div>
      <p class="kick">02 · Услуги</p>
      <h2 class="lm" style="margin-top:10px"><span class="scr" data-text="Что мы делаем">Что мы делаем</span></h2>
    </div>
    <span class="kick">Полный цикл</span>
  </div>

  <div class="rv">
    <div class="srow">
      <span class="idx">/01</span>
      <h3 class="fd" data-t="svc1Title">Брендинг и айдентика</h3>
      <div><p data-t="svc1Desc">Стратегия, нейминг, логотип и гайдлайны — системы, которые живут годами и работают на бизнес.</p>
      <div class="chips"><span class="chip">Стратегия</span><span class="chip">Логотип</span><span class="chip">Гайдлайн</span></div></div>
      <span class="arw">→</span>
    </div>
    <div class="srow">
      <span class="idx">/02</span>
      <h3 class="fd" data-t="svc2Title">Сайты и продукты</h3>
      <div><p data-t="svc2Desc">Корпоративные сайты, промо и интерфейсы: от исследования и прототипа до запуска и поддержки.</p>
      <div class="chips"><span class="chip">UX</span><span class="chip">UI</span><span class="chip">Разработка</span></div></div>
      <span class="arw">→</span>
    </div>
    <div class="srow">
      <span class="idx">/03</span>
      <h3 class="fd" data-t="svc3Title">Motion и 3D</h3>
      <div><p data-t="svc3Desc">Анимация логотипов, ролики, WebGL-сцены и 3D-графика, которые делают бренд осязаемым.</p>
      <div class="chips"><span class="chip">2D/3D</span><span class="chip">WebGL</span><span class="chip">Ролики</span></div></div>
      <span class="arw">→</span>
    </div>
    <div class="srow">
      <span class="idx">/04</span>
      <h3 class="fd" data-t="svc4Title">Развитие продукта</h3>
      <div><p data-t="svc4Desc">Дизайн-системы, контент, A/B-тесты — растим запущенные продукты как свои собственные.</p>
      <div class="chips"><span class="chip">Дизайн-системы</span><span class="chip">A/B</span><span class="chip">Контент</span></div></div>
      <span class="arw">→</span>
    </div>
  </div>
</section>

<!-- ============ СТУДИЯ ============ -->
<section class="wrap" id="studio">
  <div class="shead rv">
    <div>
      <p class="kick">03 · Студия</p>
      <h2 class="lm" style="margin-top:10px"><span class="scr" data-text="Люди и принципы">Люди и принципы</span></h2>
    </div>
    <span class="kick">18 человек · 9 стран</span>
  </div>

  <div class="grid">
    <div class="cell c7 card lift pad about rv">
      <p class="big" data-t="aboutText">BST — компактная команда арт-директоров, дизайнеров и инженеров. Мы собираем бренды как <span class="hl">модульные системы</span>: один каркас — бесконечность характеров. Доказательство — этот сайт: переключите тему в шапке и посмотрите, как один код становится <span class="hl">четырьмя брендами</span>.</p>
      <p class="sig" data-t="aboutSig">— Кира Бест, основатель BST®</p>
    </div>

    <div class="cell c5 card lift pad rv">
      <p class="kick" style="margin-bottom:14px">Признание</p>
      <div class="award"><b data-t="aw1Name">Awwwards · Site of the Day ×3</b><span>2025</span></div>
      <div class="award"><b data-t="aw2Name">CSSDA · Best UI &amp; UX</b><span>2024</span></div>
      <div class="award"><b data-t="aw3Name">FWA · of the Day</b><span>2024</span></div>
      <div class="award"><b data-t="aw4Name">Behance · Featured Interaction</b><span>2023</span></div>
      <div class="award"><b data-t="aw5Name">Рейтинг Рунета · Топ-10 студий</b><span>2022</span></div>
    </div>

    <div class="cell c7 card lift pad rv">
      <p class="kick">Голоса клиентов</p>
      <p class="tst-q" id="tstQ" style="margin-top:18px">«BST переосмыслили наш бренд так, что продажи выросли на 70% за квартал. Это не дизайн — это стратегия в пикселях.»</p>
      <p class="tst-a" id="tstA">Мария Сойкина — CEO ORBITA</p>
      <div class="tst-bar"><i id="tstBar"></i></div>
    </div>

    <div class="cell c5 card rv clients" style="display:flex;flex-direction:column;justify-content:center;gap:20px">
      <div class="mq"><div class="mq-t">
        <div class="mq-g"><span>ORBITA</span><b>✳</b><span>NORD</span><b>✳</b><span>KIVI</span><b>✳</b><span>HELIX LAB</span><b>✳</b><span>FORMA</span><b>✳</b></div>
        <div class="mq-g"><span>ORBITA</span><b>✳</b><span>NORD</span><b>✳</b><span>KIVI</span><b>✳</b><span>HELIX LAB</span><b>✳</b><span>FORMA</span><b>✳</b></div>
      </div></div>
      <div class="mq rev"><div class="mq-t">
        <div class="mq-g"><span>LUNA</span><b>✳</b><span>VOLNA</span><b>✳</b><span>ATLAS</span><b>✳</b><span>SINTAX</span><b>✳</b><span>MIRAGE</span><b>✳</b></div>
        <div class="mq-g"><span>LUNA</span><b>✳</b><span>VOLNA</span><b>✳</b><span>ATLAS</span><b>✳</b><span>SINTAX</span><b>✳</b><span>MIRAGE</span><b>✳</b></div>
      </div></div>
    </div>

    <div class="cell c4 card acc lift pad hire rv sm1">
      <p class="kick" style="color:inherit;opacity:.7">Вакансии</p>
      <p class="fd" data-t="hireText" style="margin-top:12px">Растём: ищем арт-директора и моушн-дизайнера</p>
      <a class="btn" style="margin-top:18px;background:var(--acc-ink);color:var(--acc);border-color:var(--acc-ink)" href="#contact">Откликнуться ↗</a>
    </div>

    <div class="cell c8 card lift pad rv">
      <p class="kick" style="margin-bottom:16px">Инструменты</p>
      <div class="toolgrid">
        <span class="chip">Figma</span><span class="chip">Blender</span><span class="chip">After Effects</span><span class="chip">Cinema 4D</span><span class="chip">GSAP</span><span class="chip">Three.js</span><span class="chip">Framer</span><span class="chip">Notion</span>
      </div>
    </div>
  </div>
</section>

<!-- ============ КОНТАКТЫ ============ -->
<section class="wrap" id="contact">
  <div class="shead rv">
    <div>
      <p class="kick">04 · Контакты</p>
      <h2 class="lm" style="margin-top:10px"><span class="scr" data-text="Начнём проект">Начнём проект</span></h2>
    </div>
    <span class="kick">2 окна в квартал</span>
  </div>

  <div class="card lift pad contact-card rv">
    <div>
      <h2 data-t="ctaTitle">Соберём ваш бренд<br>как <em class="emx" style="font-style:normal">конструктор</em></h2>
      <button class="mail" id="copyMail" title="Скопировать e-mail">hello@bst.studio ⧉</button>
      <p class="meta-line" data-t="ctaMeta" style="margin-top:18px">Ответим в течение 24 часов · NDA по запросу</p>
    </div>
    <div class="clist">
      <div><span>Telegram</span><a href="#contact">@bst_studio ↗</a></div>
      <div><span>Адрес</span><a href="#contact">Москва, Б. Никитская 12 ↗</a></div>
      <div><span>Behance</span><a href="#contact">/bst ↗</a></div>
      <div><span>Dribbble</span><a href="#contact">/bst ↗</a></div>
      <div><span>VK</span><a href="#contact">/bst.studio ↗</a></div>
    </div>
  </div>
</section>
</main>

<!-- ============ ФУТЕР ============ -->
<div class="brandbar mq" aria-hidden="true">
  <div class="mq-t">
    <div class="mq-g"><span>BST NOIR</span><b>✳</b><span>BST ATELIER</span><b>✳</b><span>BST PULSE</span><b>✳</b><span>BST GARDEN</span><b>✳</b><span>Один код — четыре бренда</span><b>✳</b></div>
    <div class="mq-g"><span>BST NOIR</span><b>✳</b><span>BST ATELIER</span><b>✳</b><span>BST PULSE</span><b>✳</b><span>BST GARDEN</span><b>✳</b><span>Один код — четыре бренда</span><b>✳</b></div>
  </div>
</div>

<footer class="wrap">
  <div class="wm" aria-hidden="true">BST</div>
  <div class="foot-row">
    <span>© 2026 BST® Studio</span>
    <span>Тема: <span id="themeName2">NOIR</span> · Сделано в Москве</span>
    <a href="#top">Наверх ↑</a>
  </div>
</footer>

<div class="toast" id="toast">hello@bst.studio — скопировано</div>
`

// ── Engine JS ─────────────────────────────────────────────────────────────────
function neoPortfolioEngineJs(brand: string, mode: 'canvas' | 'preview'): string {
  return `
(function(){
'use strict';
var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- ТЕМЫ ---------- */
var THEMES = {
  noir:    {name:'NOIR',    tag:'Форма. Ритм. Контраст.', bg:'#0A0A0B'},
  atelier: {name:'ATELIER', tag:'Тепло ручного ремесла — в цифре.', bg:'#F3EDE2'},
  pulse:   {name:'PULSE',   tag:'Интерфейсы со скоростью света.', bg:'#06060E'},
  garden:  {name:'GARDEN',  tag:'Дизайн, который дышит.', bg:'#E8EEE2'}
};
var themeNameEl = document.getElementById('themeName'),
    themeName2  = document.getElementById('themeName2'),
    taglineEl   = document.getElementById('tagline'),
    metaTheme   = document.getElementById('metaTheme');

function setTheme(id, first){
  var t = THEMES[id]; if(!t) return;
  document.documentElement.dataset.theme = id;
  localStorage.setItem('bst-theme', id);
  metaTheme.setAttribute('content', t.bg);
  document.querySelectorAll('[data-set-theme]').forEach(function(b){
    b.classList.toggle('is-on', b.dataset.setTheme === id);
  });
  themeName2.textContent = t.name;
  scramble(themeNameEl, t.name, 600);
  if(!first){
    taglineEl.classList.add('swap');
    setTimeout(function(){ taglineEl.textContent = t.tag; taglineEl.classList.remove('swap'); }, RM?0:260);
  } else { taglineEl.textContent = t.tag; }
}
document.querySelectorAll('[data-set-theme]').forEach(function(b){
  b.addEventListener('click', function(){ setTheme(b.dataset.setTheme); });
});

/* ---------- SCRAMBLE ---------- */
var GLYPHS = 'BSTАВДЕКМНОРСТУХ#%&@<>*+=/';
function scramble(el, text, dur){
  if(!el) return;
  if(RM){ el.textContent = text; return; }
  dur = dur || 900;
  var len = text.length, start = performance.now();
  (function tick(now){
    var p = Math.min(1, (now - start) / dur), solved = Math.floor(p * len), out = '';
    for(var i = 0; i < len; i++){
      var ch = text[i];
      out += (ch === ' ') ? ' ' : (i < solved ? ch : GLYPHS[Math.random()*GLYPHS.length|0]);
    }
    el.textContent = out;
    if(p < 1) requestAnimationFrame(tick); else el.textContent = text;
  })(start);
}
window.addEventListener('load', function(){
  document.querySelectorAll('h1 .scr').forEach(function(el, i){
    setTimeout(function(){ scramble(el, el.dataset.text, 1000); }, i*180);
  });
});

/* ---------- REVEAL + SCRAMBLE H2 + COUNTERS ---------- */
var io = new IntersectionObserver(function(es){
  es.forEach(function(e){
    if(!e.isIntersecting) return;
    e.target.classList.add('in');
    e.target.querySelectorAll('[data-text].scr').forEach(function(s){
      if(!s.dataset.done){ s.dataset.done = 1; scramble(s, s.dataset.text, 900); }
    });
    e.target.querySelectorAll('.count').forEach(runCount);
    io.unobserve(e.target);
  });
},{threshold:.18});
document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });

function runCount(el){
  if(el.dataset.done) return; el.dataset.done = 1;
  var to = +el.dataset.to, suf = el.dataset.suf || '';
  if(RM){ el.textContent = to + suf; return; }
  var start = performance.now();
  (function tick(now){
    var p = Math.min(1,(now-start)/1400), e = 1 - Math.pow(1-p,3);
    el.textContent = Math.round(to*e) + (p===1?suf:'');
    if(p<1) requestAnimationFrame(tick);
  })(start);
}

/* ---------- ЧАСЫ MSK ---------- */
var clock = document.getElementById('clock');
var fmt = new Intl.DateTimeFormat('ru-RU',{timeZone:'Europe/Moscow',hour:'2-digit',minute:'2-digit',second:'2-digit'});
setInterval(function(){ clock.textContent = fmt.format(new Date()); }, 1000);
clock.textContent = fmt.format(new Date());

/* ---------- ФОКУС (ротация) ---------- */
var FOCUS = ['Финтех-платформа ORBITA','Ребрендинг NORD','3D-лендинг HELIX LAB','Приложение LUNA'];
var fi = 0, focusEl = document.getElementById('focusTxt');
setInterval(function(){
  fi = (fi+1) % FOCUS.length;
  if(RM){ focusEl.textContent = FOCUS[fi]; return; }
  focusEl.style.opacity = 0; focusEl.style.transform = 'translateY(8px)';
  setTimeout(function(){
    focusEl.textContent = FOCUS[fi];
    focusEl.style.opacity = 1; focusEl.style.transform = 'none';
  }, 300);
}, 4200);
focusEl.style.transition = 'opacity .3s, transform .3s';

/* ---------- ОТЗЫВЫ ---------- */
var TST = [
  {q:'«BST переосмыслили наш бренд так, что продажи выросли на 70% за квартал. Это не дизайн — это стратегия в пикселях.»', a:'Мария Сойкина — CEO ORBITA'},
  {q:'«Сайт получил три международные награды и, что важнее, конверсию ×2. Команда слышит и ведёт за собой.»', a:'Даниил Верещагин — фаундер HELIX LAB'},
  {q:'«Работать с BST — как смотреть, как кто-то собирает твой пазл быстрее тебя. Точность, вкус, сроки.»', a:'Артём Лужин — бренд-директор NORD'}
];
var ti = 0, tq = document.getElementById('tstQ'), ta = document.getElementById('tstA'), tb = document.getElementById('tstBar');
function tstRun(){ tb.classList.remove('run'); void tb.offsetWidth; if(!RM) tb.classList.add('run'); }
setInterval(function(){
  ti = (ti+1) % TST.length;
  var apply = function(){ tq.textContent = TST[ti].q; ta.textContent = TST[ti].a; tq.classList.remove('fade'); tstRun(); };
  if(RM){ apply(); return; }
  tq.classList.add('fade'); setTimeout(apply, 350);
}, 6000);
tstRun();

/* ---------- КОПИРОВАНИЕ E-MAIL ---------- */
var toast = document.getElementById('toast'), toastT;
document.getElementById('copyMail').addEventListener('click', function(){
  (navigator.clipboard ? navigator.clipboard.writeText('hello@bst.studio') : Promise.reject())
    .catch(function(){})
    .finally(function(){
      toast.classList.add('show'); clearTimeout(toastT);
      toastT = setTimeout(function(){ toast.classList.remove('show'); }, 2200);
    });
});

/* ---------- БУРГЕР ---------- */
var burger = document.getElementById('burger'), mmenu = document.getElementById('mmenu');
function closeMenu(){ mmenu.classList.remove('open'); document.body.classList.remove('lock'); }
burger.addEventListener('click', function(){
  var open = mmenu.classList.toggle('open');
  document.body.classList.toggle('lock', open);
});
mmenu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMenu); });

/* ---------- ПРОГРЕСС ---------- */
var prog = document.getElementById('progress'), ticking = false;
addEventListener('scroll', function(){
  if(ticking) return; ticking = true;
  requestAnimationFrame(function(){
    var h = document.documentElement;
    prog.style.width = (h.scrollTop / (h.scrollHeight - h.clientHeight) * 100) + '%';
    ticking = false;
  });
}, {passive:true});

/* ---------- TILT ---------- */
if(matchMedia('(hover:hover)').matches && !RM){
  document.querySelectorAll('.tilt').forEach(function(c){
    c.addEventListener('mousemove', function(ev){
      var r = c.getBoundingClientRect(),
          x = (ev.clientX - r.left)/r.width - .5,
          y = (ev.clientY - r.top)/r.height - .5;
      c.style.transform = 'perspective(900px) rotateX(' + (-y*4) + 'deg) rotateY(' + (x*4) + 'deg) translateY(-4px)';
    });
    c.addEventListener('mouseleave', function(){ c.style.transform = ''; });
  });
}

/* init */
setTheme('${brand}', true);
})();
${mode === 'canvas' ? `(function(){
  document.documentElement.classList.add('js');
  document.querySelectorAll('.rv,.lm').forEach(function(el){ el.classList.add('in'); });
  document.addEventListener('click',function(e){var a=e.target.closest('a[href]');if(a)e.preventDefault();},true);
})();` : ''}
`
}

// ── Public API ────────────────────────────────────────────────────────────────
export function getNeoPortfolioPageHtml(data: NeoPortfolioPageData, mode: 'canvas' | 'preview'): string {
  const brand = data.brand ?? 'noir'
  return `<!DOCTYPE html>
<html lang="ru" data-theme="${brand}">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<meta id="metaTheme" name="theme-color" content="#0A0A0B">
<title>BST® — Дизайн-студия · Портфолио</title>
<link rel="icon" href="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' rx='10' fill='%23D9FF3C'/%3E%3Ctext x='32' y='44' font-family='Arial' font-size='26' font-weight='900' text-anchor='middle' fill='%23000'%3EB%3C/text%3E%3C/svg%3E">
<script>(function(){document.documentElement.dataset.theme='${brand}';document.documentElement.classList.add('js');})();<\/script>
<style>${NEO_PORTFOLIO_CSS}</style>
</head>
<body>
${NEO_PORTFOLIO_HTML_BODY}
<script>${neoPortfolioEngineJs(brand, mode)}<\/script>
</body>
</html>`
}
